module.exports = __webpack_public_path__ + "img/NKcropwise01.e1da821c.svg";